





























import { defineComponent, PropType, ref } from "@vue/composition-api";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import FieldErrorMessage from "@/components/Atoms/FieldErrorMessage/index.vue";
import FieldWarnMessage from "@/components/Atoms/FieldWarnMessage/index.vue";
import FieldController from "@/components/Organisms/FieldController/index.vue";

import { useValidate } from "@/helpers/hooks/useValidate";

import { MoveOrderType } from "./types";

export default defineComponent({
  components: {
    TextField,
    FieldErrorMessage,
    FieldWarnMessage,
    FieldController
  },
  name: "InputFieldBase",
  props: {
    orderable: {
      type: Object as PropType<{ raise: boolean; lower: boolean }>,
      default: undefined
    },
    deletable: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: undefined
    },
    warnMessage: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["delete", "moveOrder"],
  setup(_, { emit }) {
    const { formErrors, getFirstErrorMessage, validate } = useValidate();
    const hovered = ref<boolean>();

    const onClickMoveOrder = (type: MoveOrderType) => {
      emit("moveOrder", type);
    };

    const onClickDelete = () => {
      emit("delete");
    };

    return {
      formErrors,
      hovered,
      getFirstErrorMessage,
      validate,
      onClickMoveOrder,
      onClickDelete
    };
  }
});
